import { NgModule } from '@angular/core';

import { FocusOnLoadDirective } from './focus-on-load.directive';

@NgModule({
    declarations: [
        FocusOnLoadDirective
    ],
    exports: [
        FocusOnLoadDirective
    ]
})
export class FocusOnLoadModule {
}
